import { computed as o, unref as r } from "vue";
const c = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, f = (t) => {
  const e = c, n = "a";
  return o(
    () => r(t) || `${n}-id-${e.prefix}-${e.current++}`
  );
};
export {
  f as useId
};
